import React from 'react';

const Disclaimer = () => {
  return (
    <div className="flex justify-center bg-gray-100 py-8 px-4 font-['Poppins']">
      <div className="w-full max-w-4xl">
        <h1 className="text-center text-xl font-medium text-[#53686A] mb-6">Disclaimer</h1>
        
        <div className="bg-white p-6 md:p-8 border border-black">
          <div className="mb-6">
            <p className="text-sm md:text-base text-gray-800 leading-relaxed">
              Welcome to Hellocer, your gateway to endless career opportunities and talent exploration. As you embark on 
              your journey through our platform, it's essential for us to clarify our terms of use and the responsibilities that 
              come with engaging in our services. This disclaimer serves as a mutual understanding between Hellocer and 
              its users, outlining the rights, obligations, and limitations associated with our platform.
            </p>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">1. Purpose and Scope: <span className="font-normal">Hellocer objectives are aimed at simplifying the job search process and enhancing 
              recruitment efficiency for employers and clients alike. We strive to provide accurate and reliable information 
              it's essential to recognize that we act solely as an intermediary between employers and clients. We do not 
              guarantee the authenticity, completeness, or suitability of all job postings or resumes featured on our platform.</span></h2>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">2. User Responsibility: <span className="font-normal">Users of Hellocer are responsible for verifying the legitimacy of job postings and the 
              credibility of employers or clients. We strongly advise in conducting researching companies and evaluating 
              candidates' qualifications, before entering into any agreements. Users should exercise caution when sharing 
              personal information and interacting with others on the platform. Hellocer cannot be held liable for any losses, 
              damages, or disputes caused by users facilitating through our platform.</span></h2>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">3. Accuracy of Information: <span className="font-normal">While we endeavor to ensure the accuracy of job postings, resumes, and other 
              content on our website, we can't guarantee that all information is up to date or error free. Employers and users 
              are responsible for maintaining the accuracy of their respective profiles and job listings. Users should report any 
              inaccuracies or suspicious activities to our support team for investigation and resolution.</span></h2>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">4. Third-Party Content and Links: <span className="font-normal">Hellocer may contain links to third-party websites, advertisements, or 
              promotional materials. While we strive to partner with reputable organizations, we do not endorse or control the 
              content, products, or services offered by these third parties. Users should review the terms of use and privacy 
              policies of external websites before engaging with them, as Hellocer will take no responsibility for the actions or 
              policies of third-party entities.</span></h2>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">5. Limitation of Liability: <span className="font-normal">In no event shall Hellocer its affiliates, or its employees be liable for any direct, indirect 
              damages arising out of connection or in connection with the use of our platform. This is not limited to loss of 
              data, loss of revenue, profits, or damages resulting from the inability to access or use our services. Users agree 
              to take responsibility and hold Hellocer harmless from any claims, or expenses arising from their use of 
              the platform.</span></h2>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">6. Changes to Disclaimer: <span className="font-normal">Hellocer reserves the right to modify or update this disclaimer at any time without prior 
              notice. It is the user's responsibility to review this disclaimer periodically for changes. Continue using of our 
              platform constitutes acceptance of any revisions to these terms.</span></h2>
          </div>

          <div className="mt-8">
            <p className="text-sm md:text-base text-gray-800 leading-relaxed">
              Thank you for choosing Hellocer for your career or recruitment needs.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;